
import React from "react"
import PropTypes from "prop-types"
import { bem } from "../../helpers"
import List from "../List/List"
import objectPath from "object-path"

/**
 * Base class for all form inputs
 *
  * @typedef {object} props
  *   @prop {string} id
  *   @prop {string} parentId
  *   @prop {string} label
  *   @prop { function( {[fieldName:string]:[fieldValues:array<string>]} ):{[fieldName:string]:[fieldValues:array<string>]} } onChange FormDataChangeProps represent the field/values that will be saved in form data. This event handler allows you to modify the FormDataChangeProps before save into form data.
  *   @prop {{ [fieldName:string]:[fieldValues:array<string>] }} formData field names and field's values
  *   @prop {{ [fieldName:string]:[fieldValues:array<string>] }} formErrors field names and field's errors
  *   @prop { function([fieldValues:object], [formData:object]):array<[error:string]> } validate Checks fieldValues agains validation rules. return an array of errors
  *   @prop {boolean} [displayErrors=true]
  *   @prop {boolean} disabled
  *   @prop {boolean} [nested=false]
  *   @prop {string} format
  *   @extends {React.Component<props>}
 */
export class BaseField extends React.Component {

  /**
   * @param {props} props
   */
  constructor(props) {
    super(props)
    this.state = {}
  }
  /**
   * Normalizes the value of form fields (checked, value, etc.)
   * @param {Event} e
   * @returns value of target
  */
  valueFromEvent = (e) => e.target.value
  hasErrors = () => this.errors().length > 0
  errors = () => objectPath.get(this.props.formErrors, this.props.id) || []
  value = () => {
    if (this.props.value !== undefined) {
      return this.props.value
    } else if (objectPath.has(this.props.formData, this.props.id)) {
      return objectPath.get(this.props.formData, this.props.id)
    }
  }

  name = () => {
    let s = []
    if (this.props.parentId) {
      s.push(this.props.parentId)
    }
    if (this.props.id) {
      s.push(this.props.id)
    }
    return s.join(".") || "";
  }

  /**
   *
   * @param {Event} e
   */
  onChange = (e) => {
    if (this.props && this.props.onChange) {
        this.props.onChange({[this.props.id]: this.valueFromEvent(e)});
    }
  }

  renderErrors = () => {
    if (this.hasErrors() && this.props.displayErrors && this.props) {
      return (
        <List
          className={bem("errors")}
          listType="none"
          data={this.errors()}
        />
      )
    }
  }

  renderLabel = () => {
    const {id, label, labelProps} = this.props
    if (label) {
      return (
        <label htmlFor={id} {...labelProps} className={bem("field", "label")}>{label}</label>
      )
    }
  }
  renderInput = () => {
    return (
      <div>Must override <code>renderInput()</code></div>
    )
  }
  renderWrapper = (props) => {
    const {
      type,
      disabled,
      children
    } = props

    return (
      <div
        className={bem(
          "field",
          "",
          [
            type || this.inputType,
            this.hasErrors() && "invalid"
          ],
          this.props.className
        )}
        disabled={disabled}
      >
        {children}
      </div>
    )
  }

  render() {
    const Wrapper = this.renderWrapper
    return (
      <Wrapper {...this.props}>
        {this.renderLabel()}
        {this.renderInput()}
        {this.renderErrors()}
      </Wrapper>
    )
  }

  static propTypes = {
    id: PropTypes.string.isRequired,
    parentId: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    formData: PropTypes.object,
    formErrors: PropTypes.object,
    validate: PropTypes.func,
    displayErrors: PropTypes.bool,
    disabled: PropTypes.bool,
    nested: PropTypes.bool,
    format: PropTypes.string
  }

   static defaultProps = {
    formData: {},
    formErrors: {},
    displayErrors: true,
    nested: false
  }
}

export default BaseField